import CustomTable from "components/CustomTable";
import styles from "./index.module.scss";
import useListContract from "./useListContract";

function ListContractTab({ isSupplier, sellerID }) {
  const { columns, dataSource, loading, pagination, handleTableChange } = useListContract({
    isSupplier,
    sellerID,
  });

  return (
    <div className={styles["address-list-container"]}>
      <CustomTable
        rowKey={(record) => record?.id}
        columns={columns}
        dataSource={dataSource}
        scroll={{ x: 800, y: null }}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </div>
  );
}

export default ListContractTab;
